import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {HistoryListSingleVoyagesLazy} from "@containers/singleVoyage/historyVoyages/HistoryListSingleVoyages.lazy";

const HistorySingleVoyagesPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <HistoryListSingleVoyagesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default HistorySingleVoyagesPage;